module.exports = __webpack_public_path__ + "img/food_detail_1.97ced3f7.svg";